<template>
  <svg
    @click="animation()"
    width="450"
    height="150"
    viewBox="0 0 133 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="f_slova"
      d="M45.3477 18.8276C45.3477 17.4349 44.4667 15.9262 43.3561 15.9262C42.3993 15.9262 40.6753 16.7925 39.6785 17.6214V29.9334H32.0914V10.4241H39.6785V12.3514C40.905 11.2219 43.0884 9.97852 45.3076 9.97852C50.2476 9.97852 52.7366 13.1037 52.7366 17.3976V29.9355H45.3477V18.8276Z"
      fill="white"
    />
    <path
      class="f_slova"
      d="M69.3671 30.2795H61.2601L61.2224 10.918H52.3926V3.78491H78.199V10.918H69.3671V30.2795Z"
      fill="white"
    />
    <path
      class="f_slova"
      d="M80.2635 10.579H87.8334V30.2795H80.2635V10.579ZM84.1024 8.02956C82.378 8.02956 80.7356 6.5853 80.7356 4.53194C80.7356 2.51626 82.3004 1.03223 84.1024 1.03223C85.8655 1.03223 87.5511 2.51626 87.5511 4.53194C87.5684 5.43905 87.2155 6.316 86.5694 6.9713C85.9232 7.62661 85.0364 8.00705 84.1024 8.02956Z"
      fill="white"
    />
    <path
      class="f_slova"
      d="M102.462 16.552C98.9975 16.552 97.8153 18.5407 97.8153 20.4922C97.8153 22.3302 99.4922 24.0566 102.387 24.0566C104.556 24.0566 105.927 23.2306 108.556 21.7292L110.543 27.208C108.258 29.0852 105.06 30.6237 101.479 30.6237C94.6606 30.6237 90.2419 27.3588 90.2419 20.5294C90.2419 13.5493 95.3083 10.3236 101.708 10.3236C104.686 10.2876 107.587 11.2536 109.933 13.0619L108.562 18.6915C106.537 17.4152 105.013 16.552 102.462 16.552Z"
      fill="white"
    />
    <path
      class="f_slova"
      d="M120.246 22.9588V30.2796H112.997L112.952 1.37634H120.246V15.2581L124.894 10.6656H131.924L132.226 11.8033L125.876 18.3684L132.565 29.0271L132.223 30.2796H125.081L120.246 22.9588Z"
      fill="white"
    />
    <path
      class="o"
      d="M12.1404 5.54253C4.74567 6.77247 1.47375 11.8551 1.47375 18.8007C1.47375 26.6286 6.26287 31.9088 15.8411 31.9088C24.984 31.9088 29.3377 26.6286 29.3377 18.8007C29.3377 11.7692 26.3197 6.64701 19.1064 5.49866V12.7429C21.072 13.7269 22.154 15.7416 22.154 18.8764C22.154 22.9517 19.7595 25.1364 15.6164 25.1364C11.4874 25.1364 8.65743 22.9517 8.65743 18.8764C8.65743 15.6873 9.98087 13.6574 12.1404 12.6926V5.54253Z"
      fill="white"
    />
    <path
      class="crvena"
      d="M17.365 3.96925H16.0591V0.449463H15.1878V3.96925H13.882V13.9722H15.1878V17.49H16.0591V13.9722H17.365V3.96925Z"
      fill="#19D684"
    />
  </svg>
</template>

<script>
export default {
  mounted() {
    this.animation();
  },
  methods: {
    animation() {
      var tl = new TimelineMax();

      tl.from(".p_slovo", 0.5, {
        yPercent: -30,
        transformOrigin: "left center",
        ease: Elastic.easeOut.config(2, 0.7),
        opacity: 0,
      })

        .from(".o", 0.5, {
          yPercent: +30,
          transformOrigin: "left center",
          ease: Power2.easeOut,
          opacity: 0,
        })

        .from(
          ".f_slova",
          1,
          {
            xPercent: +30,
            transformOrigin: "left center",
            ease: Elastic.easeOut.config(2, 0.7),
            opacity: 0,
          },
          "-=0.25"
        )

        // .from(".i_slovo", 0.5, {
        //   yPercent: -30,
        //   transformOrigin: "left center",
        //   ease: Power2.easeOut,
        //   opacity: 0,
        // })

        // .from(
        //   ".x_slovo",
        //   0.5,
        //   {
        //     yPercent: -30,
        //     transformOrigin: "left center",
        //     ease: Power2.easeOut,
        //     opacity: 0,
        //   },
        //   "-=0.25"
        // )

        // .from(".o_slovo", 0.5, {
        //   yPercent: +30,
        //   transformOrigin: "left center",
        //   ease: Power2.easeOut,
        //   opacity: 0,
        // })

        .from(
          ".crvena",
          0.5,
          {
            yPercent: -40,
            transformOrigin: "left center",
            ease: Elastic.easeOut.config(1, 0.3),
            opacity: 0,
          },
          "-=0.35"
        );
    },
  },
};
</script>

<style></style>
